import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import Navig8MessageCard from './Navig8MessageCard';
import CommonLoader from '../../../../components/common-loader/CommonLoader';

import scss from './Navig8Messages.module.scss';

function Navig8Messages() {
  const scrollableRef = useRef(null);

  const navig8AbortController = useSelector((state) => state.sonarDashboard.navig8AbortController);
  const chapters = useSelector((state) => state.sonarDashboard.navig8.chapters);

  const isLoading = Boolean(navig8AbortController);

  return (
    <ul className={scss.messagesList} ref={scrollableRef}>
      {chapters.map((chapter) => (
        <Navig8MessageCard key={`${chapter.count}-${chapter.message}`} {...chapter} />
      ))}
      <CommonLoader isLoading={isLoading} scrollableRef={scrollableRef} disableScrolling />
    </ul>
  );
}

export default Navig8Messages;
